export default __webpack_public_path__ + "static/media/lato-italic.3d147134.svg";